exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-nota-item__wrap .v-list__tile{min-height:40px!important;height:auto!important}.card-nota-item__wrap .v-list__tile .auto-desc{display:flex;flex-wrap:wrap;font-size:11px;flex-direction:column;padding:6px;align-items:center;width:100%}.card-nota-item__wrap .v-list__tile .auto-desc .tratta-desc{font-size:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/TabDettaglioNote.vue?vue&type=style&index=0&lang=scss&
// module id = 813
// module chunks = 0